import React from "react";
import { Clock, MapPin, AlertCircle, Calendar as CalendarIcon } from "lucide-react";

const UpcomingEvents = ({
  filteredUpcomingEvents,
  loading,
  styles,
  screenSize,
  language,
  theme,
  t,
  onEventClick,
}) => {
  return (
    <div style={styles.sidebarCard}>
      <h3 style={styles.sidebarTitle}>
        <Clock size={20} /> {t.upcomingEvents}
      </h3>

      {loading ? (
        <div
          style={{
            textAlign: "center",
            padding: screenSize.isMobile ? "20px 0" : "40px 0",
          }}
        >
          <div style={styles.loadingSpinner} />
        </div>
      ) : filteredUpcomingEvents.length === 0 ? (
        <div style={styles.emptyState}>
          <CalendarIcon style={styles.emptyIcon} />
          <h4 style={styles.emptyTitle}>{t.noUpcomingEvents}</h4>
          <p style={styles.emptyDescription}>{t.calendarClear}</p>
        </div>
      ) : (
        filteredUpcomingEvents.map((ev) => (
          <div
            key={ev.id}
            style={{
              padding: screenSize.isMobile ? "16px" : "20px",
              borderRadius: screenSize.isMobile ? "12px" : "16px",
              background:
                theme === "dark"
                  ? "rgba(255,255,255,0.03)"
                  : "rgba(255,255,255,0.7)",
              border:
                theme === "dark"
                  ? "1px solid rgba(255,255,255,0.08)"
                  : "1px solid rgba(0,0,0,0.06)",
              marginBottom: screenSize.isMobile ? "12px" : "16px",
              cursor: "pointer",
              transition: "all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
              backdropFilter: "blur(15px)",
            }}
            onClick={() => onEventClick(ev)}
          >
            <div
              style={{
                fontSize: screenSize.isMobile ? "14px" : "16px",
                fontWeight: "700",
                color: theme === "dark" ? "#fff" : "#1a1a1a",
                marginBottom: "8px",
                lineHeight: "1.3",
                textAlign: language === "ar" ? "right" : "left",
              }}
            >
              {ev.title}
            </div>
            <div
              style={{
                fontSize: screenSize.isMobile ? "12px" : "13px",
                color:
                  theme === "dark"
                    ? "rgba(255,255,255,0.7)"
                    : "rgba(26,26,26,0.6)",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                marginBottom: "4px",
                fontWeight: "500",
                flexDirection: language === "ar" ? "row-reverse" : "row",
                textAlign: language === "ar" ? "right" : "left",
              }}
            >
              <Clock size={14} />
              {new Date(`${ev.date}T00:00:00`).toLocaleDateString(
                language === "ar" ? "ar-EG" : "en-US"
              )}{" "}
              {language === "ar" ? "في" : "at"} {ev.time}
            </div>
            {ev.location && (
              <div
                style={{
                  fontSize: screenSize.isMobile ? "11px" : "12px",
                  color:
                    theme === "dark"
                      ? "rgba(255,255,255,0.6)"
                      : "rgba(26,26,26,0.5)",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  marginBottom: "4px",
                  fontWeight: "500",
                  flexDirection: language === "ar" ? "row-reverse" : "row",
                  textAlign: language === "ar" ? "right" : "left",
                }}
              >
                <MapPin size={12} /> {ev.location}
              </div>
            )}
            {ev.priority === "urgent" && (
              <div
                style={{
                  color: "#ef4444",
                  fontSize: screenSize.isMobile ? "11px" : "12px",
                  fontWeight: "600",
                  marginTop: "4px",
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  flexDirection: language === "ar" ? "row-reverse" : "row",
                  textAlign: language === "ar" ? "right" : "left",
                }}
              >
                <AlertCircle size={12} />
                {t.urgent}
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
};

export default UpcomingEvents;
